import { useQuery } from '@tanstack/react-query';
import { albumApi } from '../../../api/album';

export const useRelatedAlbums = (sourceId, albumSource) =>
  useQuery({
    queryKey: ['relatedAlbums', sourceId, albumSource],
    queryFn: () => albumApi.getRelatedAlbums(sourceId, albumSource),
    select: (res) => res.data,
    enabled: !!sourceId && !!albumSource,
  });

/**
 * albumDetail 캐시에서 최신 데이터를 읽어 relatedAlbums 캐시의 해당 앨범 항목을 패치한다.
 * albumDetail invalidation이 완료된 뒤 호출해야 정확한 값을 반영한다.
 */
export function syncRelatedAlbumsCache(queryClient, albumSource, sourceId) {
  const cached = queryClient.getQueryData(['albumDetail', albumSource, sourceId]);
  if (!cached?.data) return;

  const album = cached.data;
  queryClient.setQueriesData({ queryKey: ['relatedAlbums'] }, (old) => {
    if (!old?.data) return old;
    return {
      ...old,
      data: old.data.map((item) =>
        String(item.sourceId) === String(album.sourceId)
          ? {
              ...item,
              averageRating: album.averageRating,
              bookmarkCount: album.bookmarkCount,
              isStarred: album.isStarred,
            }
          : item,
      ),
    };
  });
}
